import styled from 'styled-components'
import { Link } from 'react-router-dom'

export const HomeContainer = styled.div`
  display: grid;
  padding: 0px 20px;
  box-sizing: border-box;
  .slick-slider {
    display: grid;
  }
  @media screen and (min-width: 1100px) {
    padding: 0px;
  }
    
`
export const HomeTopContainer = styled.div`
  display: grid;
  position: relative;  
  padding: 0;
  box-sizing: border-box;
  .slick-slider {
    display: grid;
  }
  @media screen and (min-width: 1100px) {
    padding: 0px;
  }
  @media screen and (max-width: 1099px){
      padding: 10px 10px 0 10px;
  }
    
`

export const HomeSliderContainer = styled.div`
  display: grid;
  margin-bottom: 48px;
  @media screen and (min-width: 1100px) {
    grid-template-columns: 2.5fr 9fr 2.5fr;
    grid-column-gap: 15px;
  }

`

export const SliderAndFresh = styled.div`
    display: flex;
`

export const HomeBrandsContainer= styled.div`
    margin-bottom: 30px;
    @media screen and (max-width: 1100px){
        display: flex;
        justify-content: center;
    }
`

export const SectionWithHeading = styled.div`
  margin-top: 50px;
  display: flex;
  flex-direction: column;

  button.show-more {
    margin-top: 28px;
    align-self: center;
  }
  @media screen and (min-width: 1100px) {

  }
`

export const SectionProductSort = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-content: space-between;
  padding: 11px 14px 9px 21px;
  background-color: ${props => props.theme.color.lightGrey3};
  align-items: center;

  .filter-button {
    display: flex;
    align-items: center;
    svg {
      margin: 0;
      margin-right: 10px;
    }
  }

  @media screen and (min-width: 1100px) {
    .filter-button {
      display: none;
    }
    p {
      font-size: ${props => props.theme.font.size.sm};
      color: ${props => props.theme.color.black2};
    }
  }

`

export const SectionHeading = styled.h2`
  font-family: ${props => props.theme.font.family.bold};
  font-size: 17px;
  color: ${props => props.theme.color.black};
  padding-bottom: 16px;
  border-bottom: 1px solid ${props => props.theme.color.greyED};
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    display: grid;
    grid-template-columns: auto 1fr;
    grid-column-gap: 25px;
    align-items: center;
  }

  &:after {
    content: '';
    width: 204px;
    height: 1px;
    position: absolute;
    left: 0;
    bottom: -1px;
    background-color: ${props => props.theme.color.orange};
  }
  @media screen and (min-width: 1100px) {
    font-size: ${props => props.theme.font.size.lg};
  }

`

export const SectionLink = styled(Link)`
  font-size: 12px;
  color: ${props => props.theme.color.black2};
  text-decoration: none;

  svg {
    margin-left: 9px;
  }
  @media screen and (min-width: 1100px) {
    ${props => props.theme.font.size.sm};
  }

`

export const DailyOffer = styled.div`
  display: grid;
  margin-top: 23px;
  grid-template-columns: 1fr 1fr;
  grid-column-gap: 23px;
  grid-row-gap: 23px;
  @media screen and (min-width: 1100px) {
    grid-template-columns: repeat(6, 1fr);
    grid-column-gap: 29px;
  }
`

export const SpecialOffer = styled.div`
  display: grid;
  margin-top: 23px;
  grid-row-gap: 16px;
  @media screen and (min-width: 1100px) {
    grid-template-columns: ${props => props.hasOffer ? '3fr 9fr' : '1fr'};
    grid-column-gap: 29px;
  }
`

export const SpecPrice = styled.div`
  padding: 15px 27px;
  border-radius: 12px;
  box-shadow: 0px 3px 10px rgba(141,162,177,0.16);
  display: flex;
  flex-direction: column;
  align-items: center;


  p.desc {
    font-size: ${props => props.theme.font.size.sm};
    color: ${props => props.theme.color.grey2};
    text-align: center;
    padding: 10px 0px;
    letter-spacing: -0.28px;
    margin-top: 25px;
  }
  @media screen and (min-width: 1100px) {
    padding: 15px 30px;
    min-width: 447px;
  }


`

export const SpecPriceItem = styled.div`
  display: grid;
  width: 100%;
  position: relative;
  grid-column-gap: 30px;
  justify-content: center;
  grid-template-areas: 'image price'
                       'image title';


  
  .specPriceSale-desktop {
    width: 100%;
  }

  p.sale {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    position: absolute;
    top: 70px;
    left: 100px;

    i {
      width: 34px;
      height: 34px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 100%;
      background-color: ${props => props.theme.color.orange};
      color: ${props => props.theme.color.white};
      text-transform: uppercase;
      font-size: 10px;
      font-weight: bold;
      font-style: normal;
      font-family: ${props => props.theme.font.family.bold};
    }
  }

  img {
    width: 130px;
    grid-area: image;
  }

  h2 {
    font-size: 13px;
    color: ${props => props.theme.color.blue1};
    line-height: 1.42;
    font-family: ${props => props.theme.font.family.medium};
    font-weight: normal;
    max-width: 170px;
    grid-area: title;
  }

  p.price {
    display: flex;
    align-items: center;
    margin-bottom: 7px;
    margin-top: 20px;
    font-size: 15px;
    color: ${props => props.theme.color.black1};
    font-family: ${props => props.theme.font.family.medium};
    letter-spacing: -0.36px;

    grid-area: price;

    span {
      margin-left: 13px;
      font-size: 16px;
      color: ${props => props.theme.color.black1};
      letter-spacing: -0.28px;
      text-decoration: line-through;
    }
  }

  @media screen and (min-width: 1100px) {
    display: flex;
    flex-direction: column;
    align-items: center;

    p.sale {
      position: unset;
      span {
        font-size: ${props => props.theme.font.size.md};
        color: ${props => props.theme.color.black2};
        font-weight: bold;
        font-family: ${props => props.theme.font.family.bold};
      }

      i {
        width: 75px;
        height: 75px;
        font-size: ${props => props.theme.font.size.md};
      }
    }

    img {
      width: 300px;
    }

    h2 {
      font-size: 15px;
      text-align: center;

    }

    p.price {
      font-size: 22px;
      justify-content: center;

      span {
        font-size: 16px;
      }
    }

  }

`

export const SpecProduct = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 23px;
  @media screen and (min-width: 1100px) {
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    grid-gap: 29px;
  }

`

export const OtherProducts = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 23px;
  @media screen and (min-width: 1100px) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-gap: 29px;
  }

`

export const Blogs = styled.div`
  /* display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-column-gap: 30px; */
  padding-bottom: 40px;
  .slick-slider {
    display: grid;
    max-height: 100%;
    .slick-dots {
      bottom: -25px;
    }
  }
  @media screen and (min-width: 1100px) {

  }
`

export const HomeRegistrationLine = styled.div`

  @media screen and (min-width: 1100px) {
    margin-top: 67px;

    p {
      font-size: 16px;
      color: ${props => props.theme.color.white};
      span {
        font-family: ${props => props.theme.font.family.medium};
        font-weight: 500;
      }
    }

    .send-input {
      width: 656px;
      background-color: white;
      border-radius: 23px;
    }
  }

`

export const RegistrationLineBack = styled.div`
  @media screen and (min-width: 1100px) {
    position: absolute;
    width: 100%;
    left: 0;
    height: 70px;
    z-index: 0;
    background-color: ${props => props.theme.color.blue5};
  }
`
export const RegistrationLineContent = styled.div`
  @media screen and (min-width: 1100px) {
    position: relative;
    height: 70px;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0px 39px 0px 32px;
  }

`
